import Vue from 'vue'
import VueI18n from 'vue-i18n';
import Base from './baseLocale';
import Service from './serviceLocale';
import Authorization from './authorizationLocale';
import User from './userLocale';
import de from "vee-validate/dist/locale/de.json";
import fields from './fieldsLocale';
import Errors from './errorsLocale';
import MasterData from './masterDataLocale';
import Person from './personLocale';
import Factory from './factoryLocale';
import Contact from './contactLocale';
import PigSty from './pigStyLocale';
import ArticleLocale from './articleLocale';
import AdditionDeLocale from './addition.de'
import AccountingDe from "./accounting.de";
import SlaughterDe from "./slaughter.de";
import PigPriceDe from './pigPriceLocale.de';
import Comment from './commentLocale'
import DeliveryDe from './delivery.de'
import PigRegistrationDe from './pigRegistration.de'
import transporter from "@/localization/transporter";
import transport from "@/localization/transport";
import reporting from './reporting.de';
import earmark from './earmark.de';
import individualReport from './individualReport.de';
import pigLetDe from './pigLet.de';
import blobDe from "@/localization/blob.de";
import jobDe from '@/localization/jobs.de';
import BabyPigletDe from "@/localization/baby-piglet.de";

Vue.use(VueI18n);

const messages = {
    de: {
      base: Base.de,
      service: Service.de,
      auth: Authorization.de,
      comment: Comment.de,
      delivery: DeliveryDe,
      user: User.de,
      fields: fields.de,
      validation: de.messages,
      errors: Errors.de,
      masterData: MasterData.de,
      person: Person.de,
      factory: Factory.de,
      contact: Contact.de,
      pigSty: PigSty.de,
      article: ArticleLocale.de,
      addition: AdditionDeLocale,
      accounting: AccountingDe,
      slaughter: SlaughterDe,
      pigPrice: PigPriceDe,
      pigRegistration: PigRegistrationDe,
      transport,
      transporter,
      reporting,
      earmark,
      individualReport,
      piglet: pigLetDe,
      blob: blobDe,
      jobs: jobDe,
      babyPiglet: BabyPigletDe
    }
  }
;

const i18n = new VueI18n({
  locale: 'de', // set locale
  messages, // set locale messages,
  silentFallbackWarn: true,
});

export default i18n;
